import React from 'react';
import { motion } from 'framer-motion';
import { PillIcon, MonitorIcon, FlaskConicalIcon, BoxIcon } from 'lucide-react';
const reasons = [{
  icon: PillIcon,
  text: 'Las pastillas para dormir solo sedan tu cerebro, pero no resuelven la tensión energética de tus órganos.'
}, {
  icon: MonitorIcon,
  text: 'La higiene del sueño clásica (quitar pantallas) es útil, pero no detiene el ciclo de pensamientos circulares a las 3 AM.'
}, {
  icon: FlaskConicalIcon,
  text: 'La melatonina es una solución química para un problema de flujo de energía vital (Qi).'
}, {
  icon: BoxIcon,
  text: 'Contar ovejas o meditar es imposible cuando tu corazón late rápido y tus pies se sienten inquietos.'
}];
export function WhyFails() {
  return <section className="w-full bg-navy-800 px-4 py-20" data-id="element-181">
      <div className="max-w-5xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-183">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-184">
            Por Qué Lo Que Intentaste No Funcionó
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-185"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-186">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-navy-900/50 border border-white/10 rounded-lg p-6 flex gap-4" data-id="element-187">
              <div className="flex-shrink-0" data-id="element-188">
                <div className="w-12 h-12 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-189">
                  <reason.icon className="w-6 h-6 text-gold" data-id="element-190" />
                </div>
              </div>
              <p className="text-gray-300 leading-relaxed" data-id="element-191">{reason.text}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}